import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './virtualstart_styles/launch.css';

export default function StartLaunch() {
  return (
    <>
      <Container className='mt-5 mb-5 start_launch'>
        <Row>
          <Col lg={6}>
            <div className="launch_head">
              <h2>Token Launch Platform for Innovative & Advanced Projects</h2>
            </div>
            <div className="launch_para">
              <p>Claim free token airdrop on Virtual Exchange</p>
            </div>
          </Col>  
          <Col lg={6}>
            <div className="card rounded start_launch_card">
                <div className="launch_head2 d-flex justify-content-md-start justify-content-center">
                  <p>ATH ROI</p>
                </div>
                <div className="launch_card_data d-flex flex-md-row flex-column justify-content-md-between align-items-center justify-content-center">
                  <div className="launch_card">
                    <p>8833.8%</p>
                    <span>PixeVerse(PIXEL)</span>
                  </div>
                  <div className="launch_card">
                    <p>8600.0%</p>
                    <span>DefiLand(DEFILAND)</span>
                  </div>
                  <div className="launch_card">
                    <p>8250.0%</p>
                    <span>ArtWallet(1ART)</span>
                  </div>
                </div>
            </div>
          </Col>
        </Row>  
      </Container>  
    </>
  )
}